import _ from 'lodash';
import moment from 'moment-timezone';
import api from '../../utils/service';
import { downloadJsonFile } from '../../utils/download';
import { loadingCycle } from './page';
import { getAllPaymentRecords } from './paymentRecord';

const CREATE_VOID_SUCCESS = 'redux/void/CREATE_VOID_SUCCESS';
const CREATE_VOID_FAIL = 'redux/void/CREATE_VOID_FAIL';
const GET_VOID_SUCCESS = 'redux/void/GET_VOID_SUCCESS';
const GET_VOID_FAIL = 'redux/void/GET_VOID_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_VOID_SUCCESS:
      return {
        ...state,
        details: action.data,
      };
    case CREATE_VOID_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getVoid({ dealerId, paymentId }) {
  return (dispatch) =>
    loadingCycle(api.get(`/voids?paymentId=${paymentId}`))
      .then(({ data }) => {
        downloadJsonFile(
          data,
          `DEALER ${dealerId} VOID ${moment(_.get(data.created)).format('YYYYMMDD')}`,
        );
        return dispatch(getVoidSuccess(data));
      })
      .catch((error) => dispatch(getVoidFail(error)));
}

export function createVoid(payload) {
  return (dispatch) =>
    loadingCycle(api.post('/voids', payload))
      .then(({ data }) => {
        dispatch(createVoidSuccess(data));
        return dispatch(getAllPaymentRecords());
      })
      .catch((error) => dispatch(createVoidFail(error)));
}

export function createVoidSuccess(data) {
  return {
    type: CREATE_VOID_SUCCESS,
    data,
  };
}

export function createVoidFail(error) {
  return {
    type: CREATE_VOID_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function getVoidSuccess(data) {
  return {
    type: GET_VOID_SUCCESS,
    data,
  };
}

export function getVoidFail(error) {
  return {
    type: GET_VOID_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
